export const QuoteBadge = {
  EXPIRED: 'EXPIRED',
  BOOK: 'BOOK',
  BOOKED: 'BOOKED',
  INCOMPLETE: 'INCOMPLETE',
};
